<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="15"
      cy="15"
      r="14.5"
      fill="#F9F7ED"
      stroke="#205441"
    />
    <mask
      id="mask0_85_1725"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="6"
      y="6"
      width="18"
      height="18"
    >
      <rect
        x="6"
        y="6"
        width="18"
        height="18"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_85_1725)">
      <path
        d="M13.1621 19.993L8.36084 15.1918L9.86573 13.6869L13.1621 16.9878L20.1664 9.9834L21.6713 11.4838L13.1621 19.993Z"
        fill="#00C070"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CheckSvg',
};
</script>

<style lang="scss" scoped>
</style>
